<template>
  <div class="ibox" style="margin-bottom: 12px;">
    <div class="ibox-title collapse-link schedual_header pesudo_click" ref="collapseLink" v-on:click="onCollapseLinkClick">

      <div class="col-md-11 col-xs-11 schedule-header-title visit-header-date">
<!--        <div class="time_icon_checkin" >-->
<!--          <span>({{duration}})</span>-->
<!--        </div>-->
        <div class="inline schedule-date">
          <b>
            {{duration}}  &nbsp;	  <i class="fa fa-calendar-o"></i>   &nbsp;	  {{ booking_start }} &nbsp;
            <i class="fa fa-clock-o"></i>  &nbsp;	 {{ booking_start_time }} - {{ booking_end_time }}
<!--            <div class="inline timezone" v-if="isVirtual">&nbsp;-->
<!--              <i class="fa fa-globe"></i>-->
<!--              {{ visit.timezone }} &nbsp;-->
<!--            </div>-->
          </b>
        </div>

      </div>

      <div style="padding-left:10px" class="col-xs-1 float-r chevron-down-down visit-header">
        <a class="chevron_up print-tracking-map click_me with-after-element">
        </a>
      </div>




<!--      <div class="col-md-4 col-xs-4 float-r schedual-time visit-header">-->
<!--        <div class="float-l time_icon_checkin">-->
<!--          <i class="fa fa-clock-o"></i>-->
<!--        </div>-->
<!--        <ul class="float-l">-->
<!--          <li><span>{{ booking_start_time }}</span></li>-->
<!--          <li><span>{{ booking_end_time }}</span></li>-->
<!--        </ul>-->
<!--      </div>-->
      <div class="clearfix"></div>
    </div>

    <div class="ibox-content ibox-content-visit">
      <div class="inline customer_schedual_date" v-if="isVirtual">
        <span class="local_time_customer">Local time for customer</span>
        <div class="customer_dates">
          <i class="fa fa-calendar-o"></i>{{ customer_booking_start }} &nbsp;
          <i class="fa fa-clock-o"></i>&nbsp;	 {{ customer_booking_start_time }} - {{ customer_booking_end_time }}
          <div class="inline timezone">
            <i class="fa fa-globe"></i>
            {{ visit.customer_timezone?? visit.timezone }} &nbsp;
          </div>
        </div>
      </div>
      <div class="scheduled_appointment_service" v-for="service of visit.services">
        <a :href="'#service_'+service.service_id+'_0'">
          <b>{{ service.service_name }}</b>
        </a>
      </div>

      <booking-view-contractor-tracking-map v-if="loadMap" :booking-id="visit.booking_id"
                                            :is-running-late="visit.is_running_late == 1"
                                            :visit-status="visit.scheduled_visit_job_status"
                                            :is-virtual="isVirtual"
                                            :visitBreakDownIds="visitBreakDownIds">
      </booking-view-contractor-tracking-map>
    </div>
  </div>
</template>

<script>

import $ from 'jquery'
import moment from 'moment'
import BookingViewContractorTrackingMap from "@/modules/Booking/components/maps/BookingViewContractorTrackingMap";

export default {
  name: "BookingViewScheduledVisit",

  components: {BookingViewContractorTrackingMap},
  props: {
    visit: Object,
    visitBreakDownIds: Array,
     isVirtual: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loadMap: false
    }
  },
  methods:{
    onCollapseLinkClick(){
      this.loadMap = true
      $(this.$refs['collapseLink']).toggleClass("ispendg");
      if (!$(this.$refs['collapseLink']).hasClass("ispendg")) {
        $(this.$refs['collapseLink']).children(".visit-header").children("a").addClass("with-after-element");
        $(this.$refs['collapseLink']).children(".visit-header").children("a").removeClass("without-after-element");

      } else {
        $(this.$refs['collapseLink']).children(".visit-header").children("a").removeClass("with-after-element");
        $(this.$refs['collapseLink']).children(".visit-header").children("a").addClass("without-after-element");
      }

      if($(this.$refs['collapseLink']).hasClass("pencil-parent") || $(this.$refs['collapseLink']).hasClass("fa-pencil")) {
        return;
      }

      var ibox = $(this.$refs['collapseLink']).closest('div.ibox');
      var button = $(this.$refs['collapseLink']).find('i');
      var content = ibox.find('div.ibox-content');
      content.slideToggle(200);
    // button.toggleClass('fa-chevron-down').toggleClass('fa-chevron-down');
      ibox.toggleClass('').toggleClass('border-bottom');
      setTimeout(function () {
        ibox.resize();
        ibox.find('[id^=map-]').resize();
      }, 50);
    }
  },
  computed: {



    booking_start: function () {
      return moment(this.visit.booking_start).format('dddd, D MMMM Y')
    },
    booking_start_time: function () {
      if (this.visit.part_of_day && this.visit.part_of_day !='0'){//if part of day has value then show it else show booking start and end
        let part_od_day_text  =this.visit.part_of_day.split("(");
        return part_od_day_text[0];
      } else {
        return moment(this.visit.booking_start).format('hh:mm A')
      }
    },
    booking_end_time: function () {
      if (this.visit.part_of_day && this.visit.part_of_day !='0' && this.visit.part_of_day !=null){//if part of day has value then show it else show booking start and end
        let part_od_day_range  =this.visit.part_of_day.split("(");
        if (typeof part_od_day_range[1]=='undefined'){
          return '';
        }
        return '('+part_od_day_range[1];
      } else {
        return moment(this.visit.booking_end).format('hh:mm A');
      }
    },
    customer_booking_start: function () {
      return moment(this.visit.customer_booking_start).format('dddd, D MMMM Y')
    },
    customer_booking_start_time: function () {
      if (this.visit.part_of_day && this.visit.part_of_day !='0'){//if part of day has value then show it else show booking start and end
        let part_od_day_text  =this.visit.part_of_day.split("(");
        return part_od_day_text[0];
      } else {
        return moment(this.visit.customer_booking_start).format('hh:mm A')
      }
    },
    customer_booking_end_time: function () {
      if (this.visit.part_of_day && this.visit.part_of_day !='0' && this.visit.part_of_day !=null){//if part of day has value then show it else show booking start and end
        let part_od_day_range  =this.visit.part_of_day.split("(");
        if (typeof part_od_day_range[1]=='undefined'){
          return '';
        }
        return '('+part_od_day_range[1];
      } else {
        return moment(this.visit.customer_booking_end).format('hh:mm A');
      }
    },

    duration: function () {
      console.log('this.visit.visit_time'+this.visit.visit_time);
      //if part of day then display the duration from contractor service booking table else display difference between end and start of booking
      if (this.visit.part_of_day && this.visit.part_of_day !='0' && this.visit.part_of_day !=null){
        this.visit.visit_time*=60;        //variable to declare duration of visit
        let Hour= parseInt(this.visit.visit_time / 60);
        let Min= parseInt(this.visit.visit_time % 60);
        if (Hour){
          Hour =Hour+'hr';
        }else {
          Hour= '';
        }
        if (Min){
          Min =' '+Min+'min';
        }else {
          Min= '';
        }
        return Hour+Min

      }
      /** when the end Date or Start Date is undefined day  and hours value will   not   a number NAN
       * to fix it use the moment js function and check  if value not = NAN
       * **/
      var startDate = moment(this.visit.booking_start);
      var endDate = moment(this.visit.booking_end);
      var interval  = Math.abs(endDate - startDate)/1000;
      //console.log(interval);
      var secondsInDay =  60 * 60 * 24;
      var days = Math.floor(interval / (secondsInDay));
      //console.log(days);
      var hrs = Math.floor((interval - (days * secondsInDay))/(60*60));
      //console.log(hrs);
      var mins = Math.floor((interval - (days * secondsInDay) - (hrs * 60 * 60))/60);
      //console.log(mins);
      var result = '';
      if(days != 0 && !isNaN(days)){
        result = result + days+"Days";
      }
      if(hrs != 0&& !isNaN(hrs)){
        result = result +" " + hrs+"Hrs";
      }
      if(mins != 0&& !isNaN(mins)){
        result = result + " " +  mins+"Mins";
      }
      return result;
    }




  }
}
</script>

<style scoped>
.ibox-content-visit {
  padding: 0px;
  display: none;
}

.scheduled_appointment_service {
  padding-top: 10px;
  padding-left: 10px;
  margin-bottom: 10px;
}

.timeline-visit {
  margin-right: 50% !important;
}

@media only screen and (max-width: 400px) {
  .timeline-visit {
    margin-right: 40% !important;
  }
}

.visit-header {
  padding: 0px;
}

.visit-header-date {
  padding: 0px;
}

.print-tracking-map:after {
  font-family: FontAwesome;
  content: "\f067";
}

.print-tracking-map.without-after-element:after {
  font-family: FontAwesome;
  content: "\f068";
}

.print-tracking-map.after-element:after {
  font-family: FontAwesome;
  content: "\f067";
}

@media only screen and (max-width: 600px) {
  .visit-header {
    padding-left: 5px;
    padding-right: 0px;
  }

  .time_icon_checkin {
    padding: 5px 5px 5px 10px;
  }

  .schedual_header {
    height: auto !important;
  }

}

@media only screen and (max-width: 320px) {
  .visit-header {
    padding-left: 0px;
  }

  .time_icon_checkin {
    padding: 2px 2px 2px 5px;
  }
}

.openzx {
  display: block !important;
}

.pesudo_click {
  cursor: pointer;
}
span.local_time_customer {
  font-weight: bold;
  display: block;
  padding: 5px;
}
.customer_dates{
  padding-left: 10px;
}
</style>
